import { ItemScheme } from '../../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../../Enums/MagicField.enum';
import { HealthData } from '../../Enums/HealthData.enum';
import { HealthDataType } from '../../Enums/HealthDataType.enum';

export const babyHealthDataFilterScheme: ItemScheme[] = [
	{
		type: MagicField.TEXT,
		subType: 'filterLabel',
		title: 'component.chart.filter.viewInterval',
	},
	{
		type: MagicField.RADIOLIST,
		key: 'view',
		children: [
			{
				value: 'day',
				title: 'component.chart.filter.day',
			},
			{
				value: 'week',
				title: 'component.chart.filter.week',
			},
			{
				value: 'month',
				title: 'component.chart.filter.month',
			},
			{
				value: 'year',
				title: 'component.chart.filter.year',
			},
			{
				value: 'custom',
				title: 'component.chart.filter.custom',
			},
		],
		settings: {
			required: true,
		},
	},
	{
		type: MagicField.CONDITION,
		value: 'view',
		settings: {
			rules: [
				{
					formControlKey: 'view',
					rule: 'equal',
					value: 'day',
				},
			],
		},
		children: [
			{
				type: MagicField.DATEPICKER,
				key: 'date',
				title: 'component.chart.filter.date',
				settings: {
					required: true,
				},
			},
		],
	},
	{
		type: MagicField.CONDITION,
		value: 'view',
		settings: {
			rules: [
				{
					formControlKey: 'view',
					rule: 'equal',
					value: 'day',
				},
			],
		},
		children: [
			{
				type: MagicField.RADIOLIST,
				key: 'dataType',
				children: [
					{
						value: HealthDataType.DEFAULT,
						title: 'component.chart.filter.averageValues',
					},
					{
						value: HealthDataType.RAW,
						title: 'component.chart.filter.allValues',
					},
				],
				settings: {
					required: true,
				},
			},
		],
	},
	{
		type: MagicField.CONDITION,
		value: 'view',
		settings: {
			rules: [
				{
					formControlKey: 'view',
					rule: 'equal',
					value: 'custom',
				},
			],
		},
		children: [
			{
				type: MagicField.TEXT,
				subType: 'filterLabel',
				title: 'component.chart.filter.period',
			},
			{
				type: MagicField.DATEPICKER,
				key: 'from',
				title: 'component.chart.filter.dateFrom',
				settings: {
					required: true,
				},
			},
			{
				type: MagicField.DATEPICKER,
				key: 'to',
				title: 'component.chart.filter.dateTo',
				settings: {
					required: true,
				},
			},
		],
	},
	{
		type: MagicField.TEXT,
		subType: 'filterLabel',
		title: 'component.chart.filter.chartsAndTables',
	},
	{
		type: MagicField.CHECKBOX,
		key: 'toggleVaginalBleeding',
		title: 'component.monitoring.baby.vaginalBleeding',
	},
	{
		type: MagicField.CHECKBOX,
		key: 'toggleTemperature',
		title: 'component.monitoring.baby.temperature',
	},
	{
		type: MagicField.CHECKBOX,
		key: 'toggleWeight',
		title: 'component.chart.filter.weight',
	},
	{
		type: MagicField.CHECKBOX,
		key: 'toggleUrinaryTractInfection',
		title: 'component.monitoring.baby.signsOfUrinaryInfection',
	},
	{
		type: MagicField.CHECKBOX,
		key: 'toggleVaginalInfection',
		title: 'component.monitoring.baby.signsOfVaginalInfection',
	},
	{
		type: MagicField.CHECKBOX,
		key: 'toggleVomiting',
		title: 'component.monitoring.baby.vomiting',
	},
	{
		type: MagicField.CHECKBOX,
		key: 'toggleDiarrhoea',
		title: 'component.monitoring.baby.diarrhealPictures',
	},
	{
		type: MagicField.CHECKBOX,
		key: 'toggleSwelling',
		title: 'component.monitoring.baby.edema',
	},
	{
		type: MagicField.CHECKBOX,
		key: 'toggleMedicaments',
		title: 'component.monitoring.baby.medicationReaction',
	},
	{
		type: MagicField.CHECKBOX,
		key: 'toggleBloodPressure',
		title: 'component.chart.filter.bloodPressureAndHearthBeat',
	},
	{
		type: MagicField.CHECKBOX,
		key: 'toggleGlycemia',
		title: 'component.chart.filter.glycemia',
	},
	{
		type: MagicField.CHECKBOX,
		key: 'toggleAmnioticFluidLeak',
		title: 'component.monitoring.baby.amnioticFluidLeak',
	},
	{
		type: MagicField.CHECKBOX,
		key: 'toggleHypertensionSymptoms',
		title: 'component.monitoring.baby.hypertensionSymptoms.text',
	},
	{
		type: MagicField.CHECKBOX,
		key: 'toggleFetalMovements',
		title: 'component.monitoring.baby.fetalMovements',
	},
	{
		type: MagicField.CHECKBOX,
		key: 'toggleBreastSelfAssessment',
		title: 'component.monitoring.baby.breastSelfAssessment',
	},
	{
		type: MagicField.CHECKBOX,
		key: 'toggleUterineContractions',
		title: 'component.monitoring.baby.uterineContractions',
	},
	{
		type: MagicField.TEXT,
		subType: 'filterLabel',
		title: 'component.chart.filter.dataSource',
	},
	{
		type: MagicField.CONTAINER,
		key: 'source',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'appleHealth',
				title: 'component.chart.filter.appleHealth',
			},
			{
				type: MagicField.CHECKBOX,
				key: 'googleFit',
				title: 'component.chart.filter.googleFit',
			},
			{
				type: MagicField.CHECKBOX,
				key: 'bioScan',
				title: 'component.chart.filter.bioScan',
			},
			{
				type: MagicField.CHECKBOX,
				key: 'questionnaire',
				title: 'component.chart.filter.questionnaires',
			},
		],
	},
];
